var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDnaLine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "40px",
    viewBox: "0 0 25 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0.000110032239 -4.5672305e-05 24.5957336 -4.5672305e-05 24.5957336 39.2848 0.000110032239 39.2848"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Operaciones",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Op_Web",
    transform: "translate(-1087.000000, -1713.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(1067.000000, 1713.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(20.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.637,34.184 C2.81,33.127 3.072,32.086 3.42,31.074 L21.221,31.074 C21.567,32.086 21.824,33.127 21.991,34.184 L2.637,34.184 Z M22.401,5.102 C22.235,6.159 21.977,7.2 21.631,8.212 L2.964,8.212 C2.618,7.2 2.361,6.159 2.195,5.102 L22.401,5.102 Z M8,23.956 C9.291,22.746 10.736,21.713 12.298,20.884 C13.866,21.715 15.319,22.748 16.618,23.956 L8,23.956 Z M17.029,15.33 C15.615,16.643 14.022,17.751 12.298,18.62 C10.574,17.751 8.981,16.643 7.567,15.33 L17.029,15.33 Z M18.862,13.33 L5.734,13.33 C4.976,12.363 4.324,11.318 3.787,10.212 L20.809,10.212 C20.272,11.318 19.619,12.363 18.862,13.33 L18.862,13.33 Z M6.18,25.956 L18.451,25.956 C19.209,26.923 19.863,27.968 20.399,29.074 L4.244,29.074 C4.778,27.97 5.427,26.925 6.18,25.956 L6.18,25.956 Z M24.1,35.184 C24.1,35.154 24.085,35.128 24.082,35.098 C23.893,33.301 23.476,31.536 22.841,29.843 C22.822,29.753 22.788,29.667 22.744,29.587 C22.004,27.69 20.972,25.919 19.684,24.341 C19.655,24.3 19.621,24.261 19.586,24.225 C18.107,22.459 16.344,20.952 14.369,19.766 C21.088,15.93 25.039,8.605 24.556,0.883 C24.491,0.334 23.994,-0.058 23.446,0.007 C22.897,0.072 22.505,0.569 22.57,1.118 C22.63,1.777 22.643,2.44 22.606,3.102 L1.99,3.102 C1.953,2.44 1.965,1.777 2.026,1.118 C2.089,0.57 1.697,0.074 1.149,0.009 C0.607,-0.06 0.111,0.324 0.042,0.866 C0.041,0.871 0.04,0.877 0.04,0.883 C-0.444,8.605 3.507,15.93 10.226,19.767 C8.253,20.952 6.49,22.458 5.012,24.222 C4.97,24.263 4.933,24.307 4.901,24.354 C3.62,25.926 2.592,27.688 1.854,29.578 C1.804,29.665 1.767,29.761 1.747,29.862 C1.12,31.538 0.707,33.287 0.516,35.066 C0.506,35.105 0.497,35.144 0.492,35.184 C0.492,35.199 0.5,35.211 0.501,35.226 C0.383,36.281 0.366,37.344 0.449,38.403 C0.514,38.952 1.012,39.343 1.561,39.278 C2.109,39.212 2.501,38.715 2.435,38.166 C2.38,37.507 2.374,36.844 2.417,36.184 L22.196,36.184 C22.233,36.845 22.221,37.509 22.159,38.168 C22.097,38.716 22.489,39.212 23.037,39.277 C23.076,39.282 23.116,39.284 23.155,39.284 C23.66,39.283 24.086,38.905 24.146,38.403 C24.23,37.341 24.212,36.275 24.094,35.216 C24.094,35.205 24.1,35.196 24.1,35.184 L24.1,35.184 Z",
    id: "Fill-1",
    fill: "#000000",
    mask: "url(#mask-2)"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDnaLine);
export default __webpack_public_path__ + "static/media/DNA-Line.74d8b2e8b5ea4c3c81d4953b8b74f736.svg";
export { ForwardRef as ReactComponent };